import { FunctionComponent } from 'react'
import { EmailUser } from '@/types/EmailHandlerType'
import styles from './account.module.scss'
import { Person, PersonOutline } from '@mui/icons-material'
import { List, ListItem, ListItemText, Tooltip } from '@mui/material'
import { Role } from '@/types/Role'
import { useTranslation } from 'react-i18next'

interface EmailDataProps {
    data?: EmailUser
    loading: boolean
}

const EmailData: FunctionComponent<EmailDataProps> = ({ data, loading }) => {
    const { t } = useTranslation()

    return loading ? (
        <PersonOutline className={`${styles.Icon} ${styles.Loading}`} />
    ) : data ? (
        <Tooltip
            placement={'top'}
            TransitionProps={{ timeout: 0 }}
            followCursor
            title={
                <List>
                    <ListItem>
                        <ListItemText
                            primary={`${t('email')}: ${data.email}`}
                            secondary={`${t('userId')}: ${data.userId}`}
                        />
                    </ListItem>
                    <ListItem>
                        {data.role === Role.parent && (
                            <ListItemText
                                primary={`${t('type')}: ${t('parent')}`}
                                secondary={`${t('idParent')}: ${data.id}`}
                            />
                        )}
                        {data.role === Role.staff && (
                            <ListItemText
                                primary={`${t('type')}: ${t('staff')}`}
                                secondary={`${t('idStaff')}: ${data.id}`}
                            />
                        )}
                        {data.role === Role.trustee && (
                            <ListItemText
                                primary={`${t('type')}: ${t('trustee')}`}
                                secondary={`${t('idTrustee')}: ${data.id}`}
                            />
                        )}
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={`${t('firstname')}: ${data.firstname}`} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={`${t('lastname')}: ${data.lastname}`} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={`${t('phone')}: ${data.phone}`} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={`${t('address')}: ${data.address}`} />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary={`${t('city')}: ${data.city}`}
                            secondary={`${t('zipCode')}: ${data.zip}`}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={`${t('country')}: ${data.country}`} secondary={' '} />
                    </ListItem>
                    <ListItem></ListItem>
                </List>
            }
        >
            <Person className={`${styles.Icon} ${styles.Validated}`} />
        </Tooltip>
    ) : (
        <Person className={`${styles.Icon} ${styles.notValidated}`} />
    )
}

export default EmailData
